import axios from 'axios';
import { AppConsts } from '../utils/AppConsts';
import { Modal } from 'antd';
import { ErrorModal } from 'components/ErrorModal';

const http = axios.create({
    baseURL: AppConsts.env.remoteServiceBaseUrl,
    timeout: 1000 * 60,
});

let showingError = false;

http.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

http.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (!showingError && error.response?.status >= 500) {
            Modal.error({
                icon: null,
                content: (
                    <ErrorModal
                        title={'Oops...'}
                        message={'Something went wrong. Try again later.'}
                        onOk={() => {
                            window.location.reload();
                            showingError = false;
                        }}
                    />
                ),
                okButtonProps: { style: { display: 'none' } },
            });
            showingError = true;
        }
        return Promise.reject(error);
    },
);

export { http };
export default http;
